import { render, staticRenderFns } from "./textImg.vue?vue&type=template&id=3e2d3d14&"
import script from "./textImg.vue?vue&type=script&lang=js&"
export * from "./textImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports